import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from "@angular/core";

import { CommonService } from "src/app/services/common.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { BaseComponent } from "../pages/base.component";
import * as Chart from "chart.js";
import * as Highcharts from "highcharts/highmaps";
import HC_map from "highcharts/modules/map";
import { environment } from "src/environments/environment";

HC_map(Highcharts);

@Component({
  selector: "app-super-admin-dashboard",
  templateUrl: "./super-admin-dashboard.component.html",
  styleUrls: ["./super-admin-dashboard.component.css"],
})
export class SuperAdminDashboardComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  @ViewChild("mapContainer", { static: false })
  mapContainer!: ElementRef<HTMLDivElement>;

  @ViewChild("subMapContainer", { static: false })
  subMapContainer!: ElementRef<HTMLDivElement>;

  selectedCounty: any = "";
  selectedCountyId: any = 0;

  donutChart!: Chart;
  subCntyDonutChart!: Chart;
  breakdownbarChart!: Chart;
  institutionsbarChart!: Chart;
  topCountysLst: any[] = [];
  institutionsList: any = [];
  countyChatsList: any = "";
  barChart!: Chart;
  barChartmonth!: Chart;
  dbDetails: any = "";
  tooltipVisible = false;
  tooltipX = 0;
  tooltipY = 0;
  tooltipTitle = "";
  lineChart!: Chart;
  countyDetails: any = "";
  countiesList: any[] = [];
  subCountyList: any[] = [];
  selectedSubCountyId: any = 0;
  modalTitle: string = "";
  modalColumns: string[] = [];
  modalDataKeys: string[] = [];
  gridList: any[] = [];
  currentModalType: string = "";

  constructor(
    CommonService: CommonService,
    toastr: ToastrService,
    private route: Router,
    private active: ActivatedRoute,
  ) {
    super(CommonService, toastr);
  }

  ngOnInit(): void {
    this.GridList();
    (this.LoadTopCountysList(), this.LoadCounties());
    // this.loadKenyaMap(),
    //  this.LoadChartsData();
    // this.LoadCountyDetails();
    // this.LoadTopSubCountysList();
    // this.LoadInstitutions(),
  }

  ngAfterViewInit(): void {}

  LoadCounties() {
    this.countiesList = [];
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetCountiesInstitutionsCount", {
      TENANTCODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.countiesList = res;
        if (this.countiesList.length > 0) {
          this.loadMap();
        }
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  async loadMap() {
    if (!this.countiesList || this.countiesList.length === 0) return;

    const topology = await fetch("assets/Maps/ke-counties.topo.json").then(
      (res) => res.json(),
    );

    const mapFeatures = Highcharts.geojson(topology);

    const mapData = mapFeatures.map((f: any) => {
      const apiCounty = this.countiesList.find(
        (c: any) =>
          c.COUNTIES_NAME?.trim().toLowerCase().replace(/\s+/g, "") ===
          f.properties.NAME_1?.trim().toLowerCase(),
      );

      return {
        name: f.properties.NAME_1, // 🔥 join key
        value: apiCounty ? apiCounty.TOTAL_INSTITUTIONS : 0,
        countyId: apiCounty ? apiCounty.COUNTIES_ID : null,
      };
    });

    const maxValue = Math.max(...mapData.map((d) => d.value), 1);

    Highcharts.mapChart(this.mapContainer.nativeElement, {
      chart: { map: topology },
      title: { text: "" },
      credits: { enabled: false },
      mapNavigation: { enabled: true },
      legend: { enabled: false },
      colorAxis: {
        min: 0,
        max: maxValue,
        stops: [
          [0, "#fee2e2"], // very light red
          [0.5, "#fca5a5"], // medium red
          [1, "#b91c1c"], // 🔥 MAX = dark red
        ],
        showInLegend: false,
      },

      series: [
        {
          type: "map",
          data: mapData,

          joinBy: ["NAME_1", "name"], // 🔥 MATCH USING COUNTY NAME

          borderColor: "#000",
          borderWidth: 1,

          states: {
            hover: { brightness: -0.3 },
          },

          dataLabels: {
            enabled: true,
            format: "{point.name}",
            color: "#000",
          },

          tooltip: {
            headerFormat: "",
            pointFormat: "<b>{point.name}</b><br/>Institutions: {point.value}",
          },
          point: {
            events: {
              click: (e: any) => {
                console.log("County:", e.point.name);
                console.log("County ID:", e.point.countyId);
                this.selectedCounty = "";
                this.selectedCountyId = "";
                setTimeout(() => {
                  this.selectedCounty = e.point.name;
                  this.selectedCountyId = e.point.countyId;
                  this.LoadSubCounties(this.selectedCountyId);
                  this.LoadChartsData(this.selectedCountyId);
                  this.LoadTopSubCountysList(this.selectedCountyId);
                }, 200);
              },
            },
          },
        },
      ],
    });
  }

  async loadSubCountyMap(countyName: string) {
    const county = this.countiesList.find(
      (c) =>
        c.COUNTIES_NAME?.trim().toLowerCase().replace(/\s+/g, "") ===
        countyName?.trim().toLowerCase(),
    );
    if (!county) return;
    const countyKey = county.COUNTIES_NAME.replace(/’|'/g, "").replace(
      / /g,
      "_",
    );

    const filePath = `assets/Maps/subcounties/${countyKey}.geo.json`;

    const geojson = await fetch(filePath).then((res) => {
      if (!res.ok) throw new Error("Sub-county map not found");
      return res.json();
    });

    const mapFeatures = Highcharts.geojson(geojson);

    const mapData = mapFeatures.map((f: any) => {
      const apiSub = this.subCountyList.find(
        (s: any) =>
          s.SUB_COUNTIES_NAME?.trim().toLowerCase().replace(/\s+/g, "") ===
          f.properties.NAME_2?.trim().toLowerCase(),
      );

      return {
        name: f.properties.NAME_2,
        value: apiSub ? apiSub.TOTAL_INSTITUTIONS : 0,
        subCountyId: apiSub ? apiSub.SUB_COUNTIES_ID : null,
      };
    });

    const maxValue = Math.max(...mapData.map((d) => d.value), 1);

    Highcharts.mapChart(this.subMapContainer.nativeElement, {
      chart: { map: geojson },
      title: { text: "" },
      credits: { enabled: false },
      legend: { enabled: false },
      colorAxis: {
        min: 0,
        max: maxValue,
        stops: [
          [0, "#fee2e2"], // very light red
          [0.5, "#fca5a5"], // medium red
          [1, "#b91c1c"], // 🔥 MAX = dark red
        ],
        showInLegend: false,
      },

      series: [
        {
          type: "map",
          data: mapData,
          joinBy: ["NAME_2", "name"], // 🔥 required

          borderColor: "#000",
          borderWidth: 1,

          enableMouseTracking: true,

          states: {
            hover: { brightness: -0.3 },
          },

          dataLabels: {
            enabled: true,
            format: "{point.name}",
            color: "#000",
          },

          tooltip: {
            headerFormat: "",
            pointFormat: "<b>{point.name}</b><br/>Institutions: {point.value}",
          },

          point: {
            events: {
              click: (e: any) => {
                console.log("SubCounty Name:", e.point.name);
                console.log("SubCounty DB ID:", e.point.subCountyId);

                this.selectedSubCountyId = e.point.subCountyId;
                this.LoadCountyDetails(this.selectedSubCountyId);
                this.LoadInstitutions();
              },
            },
          },
        },
      ],
    });
  }

  LoadSubCounties(COUNTIE_ID: any = "") {
    this.subCountyList = [];
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetSubCountiesInstitutionsCount", {
      TENANTCODE: this.TenantCode,
      COUNTIE_ID: COUNTIE_ID,
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.subCountyList = res;
        if (this.subCountyList.length > 0) {
          this.loadSubCountyMap(this.selectedCounty);
        }
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  GridList() {
    this.dbDetails = "";
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/LoadSuperAdminDashboard", {
      TENANTCODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.dbDetails = res;
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }
  searchByData(val: any) {
    this.crntPage = 1;
    this.srchFltr = val;
    this.LoadInstitutions();
  }
  setPageNumber(pagNo: number): void {
    this.crntPage = pagNo;
    this.LoadInstitutions();
  }
  LoadInstitutions() {
    this.institutionsList = [];
    this.activeSpinner();
    this.CommonService.postCall(
      "Dashboard/LoadSADashboardInstituteListBySubcounties",
      {
        TENANTCODE: this.TenantCode,
        COUNTIE_ID: +this.selectedCountyId,
        SUB_COUNTIE_ID: +this.selectedSubCountyId,
        PAGE_SIZE: this.pgSze,
        PAGE_NUMBER: this.crntPage,
        SEARCH: this.srchFltr,
      },
    ).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.institutionsList = res;
        this.institutionsList = res?.data?.data;
        ((this.ttlItms =
          res?.data?.TOTAL_RECORDS ?? this.institutionsList.length),
          (this.pageEntry = res?.data?.TOTAL_PAGES
            ? this.GetPageSizeTxt(this.crntPage, this.ttlItms)
            : this.ttlItms));
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  LoadCountyDetails(subCounty: any) {
    this.countyDetails = "";
    this.activeSpinner();
    let payLoad: any = {
      TENANTCODE: this.TenantCode,
      COUNTIE_ID: this.selectedCountyId,
      SUB_COUNTIE_ID: subCounty,
    };
    this.CommonService.postCall(
      "Dashboard/LoadSuperAdminDashboardBySubCounties",
      payLoad,
    ).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.countyDetails = res?.count;
        this.LoadSubCountyDonutChart(res?.donut);
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(
          "No Institutions Available in the Selected County or Subcounty",
        );
      },
    );
  }

  LoadTopSubCountysList(COUNTIE_ID: any) {
    // this.topCountysLst = [];
    let topSubCountys: any = "";
    this.activeSpinner();
    let payLoad: any = { TENANTCODE: this.TenantCode, COUNTIE_ID: COUNTIE_ID };
    this.CommonService.postCall(
      "Dashboard/LoadSuperAdminDashboardInstitutionsStudentsBySubCounties",
      payLoad,
    ).subscribe(
      (res: any) => {
        // if(res?.status) {
        topSubCountys = res;
        (this.LoadBreakDownBarChart(topSubCountys?.students),
          this.LoadSCBarChart(topSubCountys?.institutions),
          // } else {
          //   this.toastr.error(res?.message);
          // }
          this.CommonService.deactivateSpinner());
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  LoadTopCountysList() {
    this.topCountysLst = [];
    this.activeSpinner();
    this.CommonService.postCall("Dashboard/GetTopCountiesByInstitutions", {
      TENANTCODE: this.TenantCode,
    }).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.topCountysLst = res;
        this.loadBarChart(this.topCountysLst);
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  LoadChartsData(COUNTIE_ID: any = 0) {
    this.countyChatsList = "";
    this.activeSpinner();
    let payLoad: any = {
      TENANTCODE: this.TenantCode,
      SELECTED_YEAR: 2026,
      COUNTIE_ID: COUNTIE_ID,
    };
    this.CommonService.postCall(
      "Dashboard/LoadSuperAdminDashboardDataByCountiesId",
      payLoad,
    ).subscribe(
      (res: any) => {
        // if(res?.status) {
        this.countyChatsList = res;
        this.loadLineChart(this.countyChatsList?.graph);
        this.loadMonthWiseBarChart(this.countyChatsList?.bar);
        this.loadDonutChart(this.countyChatsList?.donut);
        // } else {
        //   this.toastr.error(res?.message);
        // }
        this.LoadCountyDetails(0);
        this.LoadInstitutions();
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  loadLineChart(data: any[]): void {
    // map API data
    const labels = data.map((x) => x.MONTH_NAME);
    const values = data.map((x) => x.INSTITUTE_COUNT);

    const canvas = document.getElementById("lineChart") as HTMLCanvasElement;

    if (this.lineChart) {
      this.lineChart.destroy();
    }

    this.lineChart = new Chart(canvas, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: "Institutes",
            data: values,
            borderColor: "#2f80ed",
            backgroundColor: "rgba(47,128,237,0.1)",
            fill: true,
            // tension: 0.4,
            pointRadius: 4,
            pointHoverRadius: 6,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
          },
        },
        // scales: {
        //   y: {
        //     beginAtZero: true
        //   }
        // }
      },
    });
  }

  loadBarChart(data: any[]): void {
    const labels = data.map((x) => x.COUNTIES_NAME);
    const values = data.map((x) => x.TOTAL_INSTITUTIONS);
    const maxVal = Math.max(...data.map((x) => x.TOTAL_INSTITUTIONS));

    const canvas = document.getElementById("barChart") as HTMLCanvasElement;

    if (this.barChart) {
      this.barChart.destroy();
    }

    this.barChart = new Chart(canvas, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Institutions",
            data: values,
            // barThickness: 35, // ✅ no colors applied
            backgroundColor: "#228B22", // ✅ Green color
            borderColor: "#0D47A1",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
          },
        },
        scales: {
          // y: {
          //   beginAtZero: true
          // }
          yAxes: [
            {
              ticks: {
                max: Math.ceil(maxVal / 10) * 10,
                beginAtZero: false,
                stepSize: 10, // your calculated step value
                precision: 0,
              },
              gridLines: {
                drawBorder: false,
              },
            },
          ],
        },
      },
    });
  }

  loadStackedBarChart(): void {
    const canvas = document.getElementById("stackedBar") as HTMLCanvasElement;

    new Chart(canvas, {
      type: "bar",
      data: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May"],
        datasets: [
          {
            label: "Basic Education Schools",
            data: [40, 55, 60, 70, 65],
            backgroundColor: "#42A5F5",
          },
          {
            label: "TVET College",
            data: [20, 25, 30, 20, 25],
            backgroundColor: "#FFA726",
          },
          {
            label: "Universities",
            data: [10, 15, 12, 8, 10],
            backgroundColor: "#EF5350",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            mode: "index",
            intersect: false,
          },
        },
        // scales: {
        //   x: {
        //     stacked: true,
        //     grid: {
        //       display: false
        //     }
        //   },
        //   y: {
        //     stacked: true,
        //     beginAtZero: true
        //   }
        // }
      },
    });
  }

  loadMonthWiseBarChart(data: any[]): void {
    const labels = data.map((x) => x.MONTH);
    const basic = data.map((x) => x.BASIC);
    const tvet = data.map((x) => x.TVET);
    const uni = data.map((x) => x.UNI);

    const canvas = document.getElementById(
      "barChartmonth",
    ) as HTMLCanvasElement;

    if (this.barChartmonth) {
      this.barChartmonth.destroy();
    }

    this.barChartmonth = new Chart(canvas, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Basic Education Schools",
            data: basic,
            backgroundColor: "#42A5F5",
          },
          {
            label: "TVET College",
            data: tvet,
            backgroundColor: "#FFA726",
          },
          {
            label: "Universities",
            data: uni,
            backgroundColor: "#EF5350",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            mode: "index",
            intersect: false,
          },
        },
        // scales: {
        //   x: {
        //     stacked: false   // 👈 IMPORTANT (grouped bars)
        //   },
        //   y: {
        //     beginAtZero: true
        //   }
        // }
      },
    });
  }

  LoadBreakDownBarChart(data: any[]): void {
    const labels = data.map((x) => x.SUB_COUNTIES_NAME);
    const values = data.map((x) => x.TOTAL_STUDENTS);
    const maxVal = Math.max(...data.map((x) => x.TOTAL_STUDENTS));
    const canvas = document.getElementById(
      "breakdownbarChart",
    ) as HTMLCanvasElement;

    if (this.breakdownbarChart) {
      this.breakdownbarChart.destroy();
    }

    this.breakdownbarChart = new Chart(canvas, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Students",
            data: values,
            barThickness: 35, // ✅ no colors applied
            backgroundColor: "#228B22", // ✅ BLUE color
            borderColor: "#0D47A1",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                max: Math.ceil(maxVal / 10) * 10,
                beginAtZero: false,
                stepSize: 10, // your calculated step value
                precision: 0,
              },
              gridLines: {
                drawBorder: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                maxRotation: 45,
                minRotation: 45,
              },
            },
          ],
        },
      },
    });
  }

  LoadSCBarChart(data: any[]): void {
    const labels = data.map((x) => x.SUB_COUNTIES_NAME);
    const values = data.map((x) => x.TOTAL_INSTITUTIONS);
    const maxVal = Math.max(...data.map((x) => x.TOTAL_INSTITUTIONS));
    const canvas = document.getElementById(
      "institutionsbarChart",
    ) as HTMLCanvasElement;

    if (this.institutionsbarChart) {
      this.institutionsbarChart.destroy();
    }

    this.institutionsbarChart = new Chart(canvas, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Institutions",
            data: values,
            barThickness: 35, // ✅ no colors applied
            backgroundColor: "#228B22", // ✅ BLUE color
            borderColor: "#0D47A1",
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                max: Math.ceil(maxVal / 10) * 10,
                beginAtZero: false,
                stepSize: 10, // your calculated step value
                precision: 0,
              },
              gridLines: {
                drawBorder: false,
              },
            },
          ],
        },
      },
    });
  }

  loadDonutChart(data: any[]): void {
    const labels = data.map((x) => x.INSTITUTION_NAME);
    const values = data.map((x) => x.INSTITUTE_COUNT);

    const canvas = document.getElementById("donutChart") as HTMLCanvasElement;

    // destroy old chart
    if (this.donutChart) {
      this.donutChart.destroy();
    }

    this.donutChart = new Chart(canvas, {
      type: "doughnut",
      data: {
        labels,
        datasets: [
          {
            label: "Institutions",
            data: values,
            // single professional color set
            backgroundColor: ["#1976D2", "#90CAF9", "#BBDEFB"],
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        // cutout: '70%',
        plugins: {
          legend: {
            position: "bottom",
          },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.label}: ${ctx.parsed}`,
            },
          },
        },
      },
    });
  }

  LoadSubCountyDonutChart(data: any[]): void {
    const labels = data.map((x) => x.INSTITUTION_NAME);
    const values = data.map((x) => x.INSTITUTE_COUNT);

    const canvas = document.getElementById(
      "subCountyDonutChart",
    ) as HTMLCanvasElement;

    // destroy old chart
    if (this.subCntyDonutChart) {
      this.subCntyDonutChart.destroy();
    }

    this.subCntyDonutChart = new Chart(canvas, {
      type: "doughnut",
      data: {
        labels,
        datasets: [
          {
            label: "Institutions",
            data: values,
            // single professional color set
            backgroundColor: ["#1976D2", "#90CAF9", "#BBDEFB"],
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        // cutout: '70%',
        plugins: {
          legend: {
            position: "bottom",
          },
          tooltip: {
            callbacks: {
              label: (ctx: any) => `${ctx.label}: ${ctx.parsed}`,
            },
          },
        },
      },
    });
  }

  // for dynamic  model popup

  columnConfigs: any = {
    totalInstitutions: {
      title: "Total Institutions",
      columns: [
        // "S. No",
        "Institution Certificate Number",
        "Institution Type",
        "Institution Name",
        "Institution Telephone Number/Landline",
        "Institution Level",
        "Sub County",
        "Created Date",
        "Constituency",
      ],
      dataKeys: [
        // "sno",
        "REGISTRATION_NO",
        "INSTITUTION_TYPE",
        "TNT_NAME",
        "MOBILENO",
        "LEVEL_NAME",
        "SUB_COUNTIES_NAME",
        "CREATEDON",
        "CON_COUNTIES_NAME",
      ],
    },
    approvedInstitutions: {
      title: "Approved Institutions",
      columns: [
        // "S. No",
        "Institution Certificate Number",
        "Institution Type",
        "Institution Name",
        "Institution Telephone Number/Landline",
        "Institution Level",
        "Sub County",
        "Created Date",
        "Constituency",
      ],
      dataKeys: [
        // "sno",
        "REGISTRATION_NO",
        "INSTITUTION_TYPE",
        "TNT_NAME",
        "MOBILENO",
        "LEVEL_NAME",
        "SUB_COUNTIES_NAME",
        "CREATEDON",
        "CON_COUNTIES_NAME",
      ],
    },
    totalStudents: {
      title: "Total Students",
      columns: [
        // "S. No",
        "Unique Learner Identifier (ULI)",
        "Learner First Name",
        "Learner Middle Name",
        "Learner Last Name",
        "Institution Name",
        "Grade",
        "Gender",
        "SNE Status",
        "SNE Type",
        "Age",
        "Created Date",
        "Constituency",
      ],
      dataKeys: [
        // "sno",
        "REGISTRATION_NUMBER",
        "FIRSTNAME",
        "MIDDLENAME",
        "LASTNAME",
        "TNT_NAME",
        "COURSE_NAME",
        "GENDER",
        "SNE_STATUS",
        "SNE_CATEGORY_NAME",
        "AGE",
        "CREATEDON",
        "CONSTITUENCY",
      ],
    },
    rejectedInstitutions: {
      title: "Rejected Institutions",
      columns: [
        // "S. No",
        "Institution Name",
        "Institution Type",
        "Institution Email",
        "Institution Telephone Number/Landline",
        "Sub County",
        "Created Date",
        "Rejected By",
        "Constituency",
      ],
      dataKeys: [
        // "sno",
        "TNT_NAME",
        "INSTITUTION_TYPE_NAME",
        "USERNAME",
        "MOBILENO",
        "SUB_COUNTIES_NAME",
        "CREATEDON",
        "NAME",
        "CON_COUNTIES_NAME",
      ],
    },
    institutionApplications: {
      title: "Institutions Applications",
      columns: [
        // "S. No",
        "Institution Certificate Number",
        "Institution Type",
        "Institution Name",
        "Institution Telephone Number/Landline",
        "Institution Level",
        "Sub County",
        "Created Date",
        "Status",
        "Constituency",
      ],
      dataKeys: [
        // "sno",
        "REGISTRATION_NO",
        "INSTITUTION_TYPE",
        "TNT_NAME",
        "MOBILENO",
        "LEVEL_NAME",
        "SUB_COUNTIES_NAME",
        "CREATEDON",
        "PENDING_STATUSES",
        "CON_COUNTIES_NAME",
      ],
    },
    specialNeedSchools: {
      title: "Special Need Schools",
      columns: [
        // "S. No",
        "Institution Certificate Number",
        "Institution Type",
        "Institution Name",
        "Institution Telephone Number/Landline",
        "Institution Level",
        "Application Type",
        "County",
        "Sub County",
        "Constituency",
        "Created Date",
      ],
      dataKeys: [
        // "sno",
        "REGISTRATION_NO",
        "INSTITUTION_TYPE",
        "TNT_NAME",
        "MOBILENO",
        "LEVEL_NAME",
        "SCHOOL_CATEGORY_NAME",
        "COUNTIES_NAME",
        "SUB_COUNTIES_NAME",
        "CON_COUNTIES_NAME",
        "CREATEDON",
      ],
    },
  };

  openModal(modalType: string, title: string) {
    this.currentModalType = modalType;
    const config = this.columnConfigs[modalType];

    if (config) {
      this.modalTitle = config.title;
      this.modalColumns = config.columns;
      this.modalDataKeys = config.dataKeys;

      // Fetch data based on modal type
      this.fetchDataForModal(modalType);

      // Open modal
      const modalElement = document.getElementById("dynamicModal");
      if (modalElement) {
        const modal = new (window as any).bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }

  fetchDataForModal(modalType: string) {
    // API call to fetch data based on modal type
    switch (modalType) {
      case "totalInstitutions":
        // Call API for total institutions
        this.getTotalInstitutionsData();
        break;
      case "approvedInstitutions":
        // Call API for approved institutions
        this.getApprovedInstitutionsData();
        break;
      case "totalStudents":
        // Call API for total students
        this.getTotalStudentsData();
        break;
      case "rejectedInstitutions":
        // Call API for rejected institutions
        this.getRejectedInstitutionsData();
        break;
      case "institutionApplications":
        // Call API for institution applications
        this.getInstitutionApplicationsData();
        break;
      case "specialNeedSchools":
        // Call API for institution applications
        this.specialNeedSchools();
        break;
    }
  }

  search(val: any, modalTitle: string) {
    this.crntPage = 1;
    this.srchFltr = val;
    switch (modalTitle) {
      case "Total Institutions":
        if (val.length > 2 || val.length == 0) {
          this.getTotalInstitutionsData();
        }
        break;
      case "Approved Institutions":
        if (val.length > 2 || val.length == 0) {
          this.getApprovedInstitutionsData();
        }
        break;
      case "Total Students":
        if (val.length > 2 || val.length == 0) {
          this.getTotalStudentsData();
        }
        break;
      case "Rejected Institutions":
        if (val.length > 2 || val.length == 0) {
          this.getRejectedInstitutionsData();
        }
        break;
      case "Institutions Applications":
        if (val.length > 2 || val.length == 0) {
          this.getInstitutionApplicationsData();
        }
        break;
      case "Special Need Schools":
        if (val.length > 2 || val.length == 0) {
          this.specialNeedSchools();
        }
        break;
    }
  }
  setPage(pagNo: number, modalTitle: string): void {
    this.crntPage = pagNo;
    switch (modalTitle) {
      case "Total Institutions":
        this.getTotalInstitutionsData();
        break;
      case "Approved Institutions":
        this.getApprovedInstitutionsData();
        break;
      case "Total Students":
        // Call API for total students
        this.getTotalStudentsData();
        break;
      case "Rejected Institutions":
        this.getRejectedInstitutionsData();
        break;
      case "Institutions Applications":
        this.getInstitutionApplicationsData();
        break;
      case "Special Need Schools":
        this.specialNeedSchools();
        break;
    }
  }

  getTotalInstitutionsData() {
    this.gridList = [];
    this.activeSpinner();
    this.CommonService.postCall("DashboardPopUp/LoadInstitutionsListPopUp", {
      FROM_DATE: "",
      TO_DATE: "",
      SCHOOLLEVEL: 0,
      TNT_PARENT_CODE: this.TenantCode,
      PAGE_SIZE: this.pgSze,
      PAGE_NUMBER: this.crntPage,
      SEARCH: this.srchFltr,
    }).subscribe(
      (res: any) => {
        // Add serial number (index) to each item
        ((this.gridList = res?.data?.data),
          ((this.ttlItms = res?.data?.TOTAL_RECORDS ?? this.gridList.length),
          (this.pageEntry = res?.data?.TOTAL_PAGES
            ? this.GetPageSizeTxt(this.crntPage, this.ttlItms)
            : this.ttlItms)));
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  getApprovedInstitutionsData() {
    let payLoad = {
      COUNTY_ID: 0,
      SUBCOUNTIES_ID: 0,
      FROM_DATE: "",
      TO_DATE: "",
      SCHOOLLEVEL: 0,
      PAGE_SIZE: this.pgSze,
      PAGE_NUMBER: this.crntPage,
      SEARCH: this.srchFltr,
    };
    this.gridList = [];
    this.activeSpinner();
    this.CommonService.postCall(
      "DashboardPopUp/LoadInstitutionsBycountyPopUp",
      payLoad,
    ).subscribe(
      (res: any) => {
        // Add serial number (index) to each item
        this.gridList = (res?.data?.data || []).map(
          (item: any, index: number) => ({
            ...item,
            sno: index + 1,
          }),
        );
        ((this.ttlItms = res?.data?.TOTAL_RECORDS ?? this.gridList.length),
          (this.pageEntry = res?.data?.TOTAL_PAGES
            ? this.GetPageSizeTxt(this.crntPage, this.ttlItms)
            : this.ttlItms));
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  getTotalStudentsData() {
    this.gridList = [];
    this.activeSpinner();
    this.CommonService.postCall(
      "DashboardPopUp/LoadLearnersByInstitutionsPopUp",
      {
        COURSE_ID: 0,
        GENDER: 0,
        FROM_DATE: "",
        TO_DATE: "",
        SCHOOLLEVEL: 0,
        PAGE_SIZE: this.pgSze,
        PAGE_NUMBER: this.crntPage,
        SEARCH: this.srchFltr,
      },
    ).subscribe(
      (res: any) => {
        // Add serial number (index) to each item
        this.gridList = (res?.data?.data || []).map(
          (item: any, index: number) => ({
            ...item,
            sno: index + 1,
          }),
        );
        ((this.ttlItms = res?.data?.TOTAL_RECORDS ?? this.gridList.length),
          (this.pageEntry = res?.data?.TOTAL_PAGES
            ? this.GetPageSizeTxt(this.crntPage, this.ttlItms)
            : this.ttlItms));
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  getRejectedInstitutionsData() {
    this.gridList = [];
    this.activeSpinner();
    this.CommonService.postCall(
      "DashboardPopUp/LoadCdeInstituteRejectListRptPopUp",
      {
        TNT_PARENT_CODE: +this.TenantCode,
        COUNTY_ID: 0,
        SUBCOUNTY_ID: 0,
        FROM_DATE: "",
        TO_DATE: "",
        SCHOOLLEVEL: 0,
        PAGE_SIZE: this.pgSze,
        PAGE_NUMBER: this.crntPage,
        SEARCH: this.srchFltr,
      },
    ).subscribe(
      (res: any) => {
        // Add serial number (index) to each item
        this.gridList = (res?.data?.data || []).map(
          (item: any, index: number) => ({
            ...item,
            sno: index + 1,
          }),
        );
        ((this.ttlItms = res?.data?.TOTAL_RECORDS ?? this.gridList.length),
          (this.pageEntry = res?.data?.TOTAL_PAGES
            ? this.GetPageSizeTxt(this.crntPage, this.ttlItms)
            : this.ttlItms));
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  getInstitutionApplicationsData() {
    this.gridList = [];
    this.activeSpinner();
    this.CommonService.postCall(
      "DashboardPopUp/LoadPendingInstitutionsByCountyPopUp",
      {
        COUNTY_ID: 0,
        SUBCOUNTIES_ID: 0,
        FROM_DATE: "",
        TO_DATE: "",
        SCHOOLLEVEL: 0,
        PAGE_SIZE: this.pgSze,
        PAGE_NUMBER: this.crntPage,
        SEARCH: this.srchFltr,
      },
    ).subscribe(
      (res: any) => {
        // Add serial number (index) to each item
        ((this.gridList = res?.data?.data),
          ((this.ttlItms = res?.data?.TOTAL_RECORDS ?? this.gridList.length),
          (this.pageEntry = res?.data?.TOTAL_PAGES
            ? this.GetPageSizeTxt(this.crntPage, this.ttlItms)
            : this.ttlItms)));
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  specialNeedSchools() {
    this.gridList = [];
    this.activeSpinner();
    this.CommonService.postCall(
      // "DashboardPopUp/LoadSpecialNeededInstitutesPopUp",
      "DashboardPopUp/LoadSpecialNeededInstitutesPopUp",
      {
        COUNTY_ID: 0,
        SUBCOUNTY_ID: 0,
        TNT_PARENT_CODE: this.TenantCode,
        SCHOOLLEVEL: 0,
        SCHOOL_CATEGORY_ID: 0,
        PAGE_SIZE: this.pgSze,
        PAGE_NUMBER: this.crntPage,
        SEARCH: this.srchFltr,
      },
    ).subscribe(
      (res: any) => {
        // Add serial number (index) to each item
        this.gridList = (res?.data?.data || []).map(
          (item: any, index: number) => ({
            ...item,
            sno: index + 1,
          }),
        );
        ((this.ttlItms = res?.data?.TOTAL_RECORDS ?? this.gridList.length),
          (this.pageEntry = res?.data?.TOTAL_PAGES
            ? this.GetPageSizeTxt(this.crntPage, this.ttlItms)
            : this.ttlItms));
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
        this.toastr.error(e?.message ?? e.error?.message);
      },
    );
  }

  getColumnValue(item: any, key: string): string {
    if (key === "sno") {
      return item[key];
    }

    let value = item[key];

    // Format date if the key is a date field
    if (key === "CREATEDON" || key === "CREATED_DATE") {
      if (value) {
        const date = new Date(value);
        return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
      }
      return "";
    }

    return value || "-";
  }

  closeModal() {
    this.gridList = [];
    this.modalColumns = [];
    this.modalDataKeys = [];
    this.srchFltr = "";
  }

  downloadPDF(type: string, modalType: string) {
    let payload: any = {};

    switch (modalType) {
      case "totalInstitutions":
        payload = {
          FROM_DATE: "",
          TO_DATE: "",
          SCHOOLLEVEL: 0,
          file_name: "TotalInstitutionsRegistered.jrxml",
          file_type: type,
          token: localStorage.getItem("tkn"),
        };
        break;

      case "approvedInstitutions":
        payload = {
          COUNTY_ID: 0,
          SUBCOUNTIES_ID: 0,
          FROM_DATE: "",
          TO_DATE: "",
          SCHOOLLEVEL: 0,
          file_name: "LoadInstitutionsByCounty.jrxml",
          file_type: type,
          token: localStorage.getItem("tkn"),
        };
        break;

      case "totalStudents":
        payload = {
          COURSE_ID: 0,
          GENDER: 0, // 22 - male, 23-female
          FROM_DATE: "",
          TO_DATE: "",
          SCHOOLLEVEL: 0,
          file_name: "CombinedLearnersForAllInstitutions.jrxml",
          file_type: type,
          token: localStorage.getItem("tkn"),
        };
        break;

      case "rejectedInstitutions":
        payload = {
          COUNTY_ID: 0,
          SUBCOUNTY_ID: 0,
          TNT_PARENT_CODE: this.TenantCode,
          FROM_DATE: "",
          TO_DATE: "",
          SCHOOLLEVEL: 0,
          file_name: "RejectedInstitutionsReport.jrxml",
          file_type: type,
          token: localStorage.getItem("tkn"),
        };
        break;

      case "institutionApplications":
        payload = {
          COUNTY_ID: 0,
          SUBCOUNTIES_ID: 0,
          FROM_DATE: "",
          TO_DATE: "",
          SCHOOLLEVEL: 0,
          file_name: "PendingInstitutionRegistrationPerCounty.jrxml",
          file_type: type,
          token: localStorage.getItem("tkn"),
        };
        break;

      default:
        // Default payload for any other case
        payload = {
          FROM_DATE: "",
          TO_DATE: "",
          SCHOOLLEVEL: 0,
          file_name: "TotalInstitutionsRegistered.jrxml",
          file_type: type,
          token: localStorage.getItem("tkn"),
        };
        break;
    }

    this.activeSpinner();
    this.CommonService.reportAPi(payload).subscribe(
      (res: any) => {
        if (res && res.data && res.data.viewPath) {
          const urlSegments = res.data.viewPath.split("/");
          const fileName = urlSegments[urlSegments.length - 1];
          const a = document.createElement("a");
          a.href = environment.downloadReportUrl + fileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          this.toastr.error("Failed to generate report");
        }
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
        this.toastr.error(
          err?.message || err?.error?.message || "Failed to download report",
        );
      },
    );
  }
}
